import { render } from "./AuthLayout.vue?vue&type=template&id=259b245a"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"
script.render = render

export default script